import { render, staticRenderFns } from "./DataImplementationSample.vue?vue&type=template&id=5ef7c176&"
import script from "./DataImplementationSample.vue?vue&type=script&lang=js&"
export * from "./DataImplementationSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports